import {HttpClient} from '@angular/common/http';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable, of } from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class Layout{
  constructor() {}

  public setLayoutSizes(): void{
    localStorage.setItem('phoneWidth', '(max-width: 991px)');
    localStorage.setItem('tabletWidth', '(max-width: 991px)');
    localStorage.setItem('pcWidth', '(min-width: 991px)');
  }




}
